import { Button } from "@progress/kendo-react-buttons";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import AppDialog, { CustomAppDialog } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { MdOutlineImageNotSupported } from "react-icons/md";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import {
  Field,
  FieldArray,
  FieldArrayRenderProps,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { closeDialog } from "../../components/dialog/dialogSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  closeGhatViewImageDialog,
  closeGhatOrderSelectionDialog,
  openGhatViewImageDialog,
  openGhatOrderSelectionDialog,
  setGhatOrderItemIndex,
  setGhatSelectOrderItemIndex,
  setGhatOrderSave,
  setGhatPreviousOrder,
} from "./ghatSlice";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { IItem } from "../item/itemModel";
import { findAllOrder, findbyOrderNo } from "../order/services/order.services";
import { IItemCategory } from "../itemcategory/itemCategoryModel";
import { LoadingPanel } from "../../components/layout/Loading";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { FaRegEye } from "react-icons/fa";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { ImCross } from "react-icons/im";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import FormTextField from "../../components/formFields/FormTextField";
import FormTextArea from "../../components/formFields/FormTextArea";
import ApprovalItemsArray from "./ApprovalItemsArray";
import Slider from "react-slick";
import {
  clearFilterOrder,
  setFilterOrder,
  setOrderImageViewPayload,
} from "../order/orderSlice";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { PROCESS_ID } from "../../_contstants/common";
import { findProductImageByProcess } from "../item/services/item.services";
import AlertBox from "../../components/common/AlertBox";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import { hasRequired } from "../../_helper/helper";
import { FetchWeight } from "../palish/services/palish.services";
import { IProcess } from "../process/processModel";

const GhatOrderDetailArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const ItemList = useAppSelector((state) => state.item.ItemList);
  const PurityList = useAppSelector((state) => state.purity.PurityList);
  const ProcessList = useAppSelector((state) => state.Process.ProcessList);
  const GhatOrderItemIndex = useAppSelector(
    (state) => state.ghat.GhatOrderItemIndex,
  );
  const GhatPreviousOrder = useAppSelector(
    (state) => state.ghat.GhatPreviousOrder,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentIndex =
    GhatOrderItemIndex === 999
      ? fieldArrayRenderProps.value.length === 0
        ? 0
        : fieldArrayRenderProps.value.length - 1
      : GhatOrderItemIndex;
  const ItemCategoryList = useAppSelector(
    (state) => state.itemCategory.ItemCategoryList,
  );

  const handleProcessChange = async (value: any) => {
    const karigar_id =
      fieldArrayRenderProps.formRenderProps.valueGetter("karigar_id");
    const order_id = fieldArrayRenderProps.formRenderProps.valueGetter(
      `ghat_item.${currentIndex}.order_id`,
    );

    fieldArrayRenderProps.formRenderProps.onChange(
      `ghat_item.${currentIndex}.process_id`,
      { value },
    );

    if (value && order_id) {
      const payload = {
        process_id: value,
        order_id: order_id,
        karigar_id: karigar_id,
      };
      const response = await dispatch(FetchWeight(payload));
      if (response?.meta?.requestStatus === "fulfilled") {
        fieldArrayRenderProps.formRenderProps.onChange(
          `ghat_item.${currentIndex}.weight`,
          { value: response.payload.Data[0].gross_weight || 0 },
        );
      } else {
        fieldArrayRenderProps.formRenderProps.onChange(
          `ghat_item.${currentIndex}.weight`,
          { value: 0 },
        );
      }
    }
  };

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        order_no: null,
        item_id: null,
        item_category_id: null,
        process_id: null,
        remarks: " ",
        purity_id: null,
        weight: null,
        approx_delivery_date: null,
        approval_items: null,
      },
    });
  }, [fieldArrayRenderProps]);

  const filterItems = (ItemCategoryID: number) => {
    if (ItemCategoryID) {
      const result = ItemList.filter((item: any) => {
        return item.item_category_id === ItemCategoryID;
      });
      return result.map((item: IItem) => {
        return {
          value: item?.id,
          label: item?.item_name,
        };
      });
    }
  };
  const handleSelectOrder = (index: any) => {
    dispatch(openGhatOrderSelectionDialog());
    dispatch(setGhatSelectOrderItemIndex(index));
  };

  const handleAddOrder = async (e: React.FormEvent) => {
    e.preventDefault();
    await fieldArrayRenderProps.formRenderProps.onSubmit(e);
    const isValid = hasRequired(fieldArrayRenderProps.formRenderProps.errors, [
      `ghat_item.${currentIndex}.approval_items.`,
      `ghat_item.${currentIndex}.order_no`,
      `ghat_item.${currentIndex}.weight`,
      `ghat_item.${currentIndex}.item_category_id`,
      `ghat_item.${currentIndex}.item_id`,
    ]);
    if (isValid) {
      dispatch(closeDialog());
      dispatch(setGhatOrderItemIndex(-1));
      dispatch(setGhatOrderSave(false));
    }
  };

  const handleFormClose = (index: any) => {
    if (GhatOrderItemIndex === 999) {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setGhatOrderItemIndex(-1));
      dispatch(setGhatOrderSave(false));
    } else {
      dispatch(closeDialog());
      dispatch(setGhatOrderItemIndex(-1));
      dispatch(setGhatOrderSave(false));
      fieldArrayRenderProps?.formRenderProps.onChange(`ghat_item.${index}`, {
        value: {
          ...GhatPreviousOrder,
          approx_delivery_date: moment(
            GhatPreviousOrder?.approx_delivery_date,
          ).toDate(),
          approval_items: GhatPreviousOrder?.approval_items?.length
            ? GhatPreviousOrder?.approval_items?.map((approvalItem: any) => {
                return {
                  ...approvalItem,
                  IssueDate: approvalItem.IssueDate
                    ? moment(approvalItem.IssueDate).toDate()
                    : null,
                };
              })
            : [],
        },
        // value: JSON.parse(GhatPreviousOrder),
      });
      dispatch(setGhatPreviousOrder(null));
    }
  };

  const handleOpenImageViewDialog = async (itemID: any) => {
    const payload = {
      process_id: PROCESS_ID.ghat,
      item_id: itemID,
    };
    await dispatch(findProductImageByProcess(payload));
    dispatch(setOrderImageViewPayload(payload));
    dispatch(openGhatViewImageDialog());
  };

  useEffect(() => {
    if (GhatOrderItemIndex === 999) {
      pushElementInarray();
    }
  }, [GhatOrderItemIndex]);

  return (
    <>
      {dialogName === "show-ghat-items-dialog" && (
        <AppDialog>
          <div style={{ width: "70vw", minHeight: "30vh" }}>
            <GridLayout
              style={{
                marginLeft: 30,
              }}
              gap={{ rows: 10, cols: 10 }}
            >
              <GridLayoutItem
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography.h4 style={{ margin: 0 }}>Add Order</Typography.h4>
                <ImCross
                  style={{
                    color: "white",
                    background: "red",
                    borderRadius: "50%",
                    padding: "5px",
                    fontSize: "24px",
                  }}
                  onClick={() => handleFormClose(currentIndex)}
                />
              </GridLayoutItem>
              {/* <GridLayoutItem> */}
              <GridLayout
                cols={[{ width: "100%" }]}
                style={{ maxHeight: "80vh", overflow: "hidden" }}
              >
                <SelectOrderDialog
                  formRenderProps={fieldArrayRenderProps.formRenderProps}
                />
                <ViewProductImages />
                {currentIndex !== null && (
                  <>
                    <GridLayoutItem
                      style={{
                        border: "1px dotted gray",
                        // background: "#ebebeb",
                        padding: "10px",
                        borderRadius: "8px",
                      }}
                    >
                      <GridLayout
                        style={{
                          marginRight: 20,
                        }}
                        gap={{ rows: 10, cols: 10 }}
                        cols={[
                          { width: "33.33%" },
                          { width: "33.33%" },
                          { width: "33.33%" },
                        ]}
                      >
                        <GridLayoutItem>
                          <Field
                            name={`ghat_item.${currentIndex}.process_id`}
                            label="Previous Process"
                            placeholder="Select Previous Process"
                            component={FormSelectionField}
                            onChange={(e) => {
                              if (e?.value) {
                                handleProcessChange(e.value);
                              }
                            }}
                            options={ProcessList?.map((process: IProcess) => {
                              return {
                                value: process.ID,
                                label: process.process_name,
                              };
                            })}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "end",
                          }}
                        >
                          <Button
                            type="button"
                            fillMode={"solid"}
                            themeColor={"primary"}
                            style={{ width: "fit-content", padding: "5px" }}
                            onClick={() => handleSelectOrder(currentIndex)}
                          >
                            Select Order
                          </Button>
                          {fieldArrayRenderProps.formRenderProps.valueGetter(
                            `ghat_item.${currentIndex}.order_no`,
                          ) !== null && (
                            <Field
                              name={`ghat_item.${currentIndex}.order_no`}
                              label="Order No"
                              placeholder="Order No"
                              disabled={"true"}
                              wrapperStyle={{ width: "70%" }}
                              component={FormTextField}
                              validator={requiredValidator}
                              astrike={true}
                            />
                          )}
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            name={`ghat_item.${currentIndex}.item_category_id`}
                            label="Product Category"
                            placeholder="Select Product Category"
                            component={FormSelectionField}
                            validator={requiredValidator}
                            astrike={true}
                            disabled={
                              !fieldArrayRenderProps.value[currentIndex]
                                ?.order_no
                                ? false
                                : true
                            }
                            options={ItemCategoryList?.map(
                              (category: IItemCategory) => {
                                return {
                                  value: category?.ID,
                                  label: category?.category_name,
                                };
                              },
                            )}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            name={`ghat_item.${currentIndex}.item_id`}
                            label="Product name"
                            placeholder="Select Product"
                            component={FormSelectionField}
                            validator={requiredValidator}
                            astrike={true}
                            disabled={
                              !fieldArrayRenderProps.value[currentIndex]
                                ?.order_no
                                ? false
                                : true
                            }
                            options={
                              ItemList &&
                              filterItems(
                                fieldArrayRenderProps.formRenderProps.valueGetter(
                                  `ghat_item.${currentIndex}.item_category_id`,
                                ),
                              )
                            }
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            name={`ghat_item.${currentIndex}.purity_id`}
                            label="Purity"
                            type="number"
                            placeholder="Select Purity"
                            component={FormSelectionField}
                            options={PurityList?.map((purity: any) => {
                              return {
                                value: purity.ID,
                                label: `${purity.Carat}-${purity.purity}`,
                              };
                            })}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem rowSpan={2}>
                          <Field
                            rows={3}
                            name={`ghat_item.${currentIndex}.remarks`}
                            label="Remarks"
                            placeholder="Write here..."
                            component={FormTextArea}
                          />
                        </GridLayoutItem>

                        <GridLayoutItem>
                          <Field
                            name={`ghat_item.${currentIndex}.approx_delivery_date`}
                            label="Approx Delivery Date"
                            format={"dd/MM/yyyy"}
                            placeholder="day/month/year"
                            component={FormDatePicker}
                            // minDate={fieldArrayRenderProps.formRenderProps.valueGetter("issue_date") || new Date(1900, 0, 1)}
                            // validator={requiredValidator}
                            // astrike={true}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            name={`ghat_item.${currentIndex}.weight`}
                            label="Estimated Weight (gm)"
                            placeholder="0.000"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            validator={requiredValidator}
                            astrike={true}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem
                          style={{
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            type="button"
                            themeColor={"info"}
                            style={{ textTransform: "uppercase" }}
                            disabled={
                              !fieldArrayRenderProps.formRenderProps.valueGetter(
                                `ghat_item.${currentIndex}.order_no`,
                              )
                            }
                            onClick={() =>
                              handleOpenImageViewDialog(
                                fieldArrayRenderProps.formRenderProps.valueGetter(
                                  `ghat_item.${currentIndex}.item_id`,
                                ),
                              )
                            }
                            fillMode="solid"
                          >
                            View Images
                          </Button>
                        </GridLayoutItem>
                      </GridLayout>
                    </GridLayoutItem>
                    {/* <hr /> */}
                    <GridLayoutItem
                      style={{
                        // boxShadow: "rgba(128, 128, 128, 0.5) 0px 0px 20px",
                        marginTop: "40px",
                        border: "1px dotted gray",
                        borderRadius: "8px",
                        padding: "5px",
                      }}
                    >
                      <FieldArray
                        formRenderProps={fieldArrayRenderProps.formRenderProps}
                        component={ApprovalItemsArray}
                        name={`ghat_item.${currentIndex}.approval_items`}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        textAlign: "end",
                        marginTop: "20px",
                        marginRight: 20,
                        width: "100%",
                      }}
                    >
                      <Button
                        type="submit"
                        fillMode={"solid"}
                        themeColor={"primary"}
                        style={{ marginRight: 4 }}
                        onClick={(e) => handleAddOrder(e)}
                      >
                        Add Order
                      </Button>
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginRight: 4 }}
                        onClick={() => handleFormClose(currentIndex)}
                      >
                        Cancel
                      </Button>
                    </GridLayoutItem>
                  </>
                )}
              </GridLayout>
              {/* </GridLayoutItem> */}
            </GridLayout>
          </div>
        </AppDialog>
      )}
    </>
  );
};

export default GhatOrderDetailArray;

interface SelectDialogProps {
  formRenderProps: FormRenderProps;
}

const SelectOrderDialog = ({ formRenderProps }: SelectDialogProps) => {
  const orderList = useAppSelector((state) => state.order.OrderList);
  const GhatSelectOrderItemIndex = useAppSelector(
    (state) => state.ghat.GhatSelectOrderItemIndex,
  );

  const dispatch = useAppDispatch();
  const ghatOrderSelectionDialog = useAppSelector(
    (state) => state.ghat.GhatOrderSelectionDialog,
  );
  const FilterOrder = useAppSelector((state) => state.order.FilterOrder);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const loading = useAppSelector((state) => state.order.loading);
  const gridRef = useRef<any>(null);

  useEffect(() => {
    const payload = {
      ...FilterOrder,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
      ProcessID: PROCESS_ID.ghat,
    };
    dispatch(findAllOrder(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyImageCommandCell = (props: GridCellProps) => {
    const handlClickItem = (image: string) => {
      if (image && typeof image === "string") {
        window.open(image);
      }
    };
    if (props.dataItem?.image === null) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <MdOutlineImageNotSupported style={{ fontSize: "30px" }} />
          <p style={{ margin: 0, fontSize: "12px" }}>No Image!</p>
        </div>
      );
    }
    return (
      <td className="action-td main-image">
        <div
          style={{
            position: "relative",
          }}
        >
          {/* <img
            className="product-image"
            src={props.dataItem?.image_name}
            alt=""
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              borderRadius: "5px",
            }}
          /> */}

          <Avatar
            className="select-order-avatar"
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: props.dataItem?.image_name
                ? "transparent"
                : "#303F9F",
            }}
          >
            {props.dataItem?.image_name ? (
              <img
                src={props.dataItem?.image_name}
                alt={`No Image`}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              `No Image`
            )}
          </Avatar>
          <div className="image-view">
            <FaRegEye
              style={{
                color: "white",
                height: 24,
                width: 24,
                cursor: "pointer",
              }}
              onClick={() => handlClickItem(props.dataItem?.image_name)}
            />
          </div>
        </div>
      </td>
    );
  };

  const MyEditCommandCell = (props: any) => {
    const handleSelectOrder = (order_no: number) => {
      formRenderProps.onChange(
        `ghat_item.${GhatSelectOrderItemIndex}.order_no`,
        {
          value: order_no,
        },
      );

      const getOrderNowiseData = async () => {
        const updateField = (field: any, value: any) =>
          formRenderProps?.onChange(
            `ghat_item.${GhatSelectOrderItemIndex}.${field}`,
            {
              value,
            },
          );

        if (!order_no || formRenderProps.modified !== true) {
          updateField("item_category_id", null);
          updateField("approx_delivery_date", "");
          updateField("item_id", null);
          updateField("remarks", " ");
          updateField("purity_id", null);
          updateField("weight", "");
          updateField("Images", null);
          return;
        }

        try {
          const { payload: res, meta } = await dispatch(
            findbyOrderNo({ order_no, process_id: PROCESS_ID.ghat }),
          );
          if (meta.requestStatus === "fulfilled" && res) {
            updateField("order_id", res?.id);
            updateField("item_category_id", res?.item_category_id);
            updateField(
              "approx_delivery_date",
              res.receive_date
                ? moment(res.receive_date, "YYYY-MM-DD").toDate()
                : "",
            );
            updateField("item_id", res?.item_id);
            updateField("remarks", res?.description || " ");
            updateField("purity_id", res?.purity);
            updateField("weight", res?.weight ? +res?.weight : "");
            updateField("Images", res?.Images ? +res?.Images : "");

            const prev_process_id = formRenderProps.valueGetter(
              `ghat_item.${GhatSelectOrderItemIndex}.process_id`,
            );
            const karigar_id = formRenderProps.valueGetter("karigar_id");
            if (prev_process_id && res?.id) {
              const payload = {
                process_id: prev_process_id,
                order_id: res?.id,
                karigar_id: karigar_id,
              };
              const fetchOrderWeight = async () => {
                const response = await dispatch(FetchWeight(payload));
                if (response?.meta?.requestStatus === "fulfilled") {
                  updateField(
                    "weight",
                    response.payload.Data[0].gross_weight || 0,
                  );
                } else {
                  updateField("weight", 0);
                }
              };
              fetchOrderWeight();
            }
          } else {
            updateField("item_category_id", null);
            updateField("approx_delivery_date", "");
            updateField("item_id", null);
            updateField("remarks", " ");
            updateField("purity_id", null);
            updateField("weight", "");
            updateField("order_no", null);
            updateField("order_id", null);
            updateField("Images", null);
          }
        } catch (error) {
          console.error(error);
        }
      };
      getOrderNowiseData();
      dispatch(clearFilterOrder());
      dispatch(closeGhatOrderSelectionDialog());
      dispatch(setGhatSelectOrderItemIndex(-1));
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <Button
          type="button"
          fillMode="solid"
          themeColor={"primary"}
          size="small"
          title="Select Order"
          onClick={() => handleSelectOrder(props.dataItem?.order_no)}
        >
          Select
        </Button>
      </td>
    );
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 6 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const OrderFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.order.FilterOrder}
        setFilterAction={setFilterOrder}
        clearFilterAction={clearFilterOrder}
        fetchDataAction={findAllOrder}
        pagination={{ case: "lowercase" }}
        extraPayload={{ ProcessID: PROCESS_ID.ghat }}
      />
    ),
    [],
  );
  return (
    <>
      <CustomAppDialog open={ghatOrderSelectionDialog}>
        <div style={{ width: "60vw", overflow: "hidden" }}>
          {loading && <LoadingPanel gridRef={gridRef} />}
          <GridLayout style={{}} gap={{ rows: 10, cols: 10 }}>
            <GridLayoutItem
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.h4 style={{ margin: 0 }}>
                {"Select Order"}
              </Typography.h4>

              <ImCross
                style={{
                  color: "white",
                  background: "red",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "24px",
                }}
                onClick={() => {
                  dispatch(closeGhatOrderSelectionDialog());
                  dispatch(setGhatSelectOrderItemIndex(-1));
                  dispatch(clearFilterOrder());
                }}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "60vw" }}>
              <KendoGrid
                className="selection-dialog responsive-table"
                scrollable="scrollable"
                style={{ maxHeight: "calc(100vh - 152px)" }}
                filterable={true}
                filter={filter}
                data={filter ? filterBy(orderList, filter) : orderList}
                total={orderList[0]?.itemcount || orderList.length}
                onFilterChange={handleFilterChange}
                skip={currentPage * pageLimit}
                take={pageLimit}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [10, 50, 100, 300, 500],
                  pageSizeValue: pageLimit,
                  type: "input",
                }}
                onPageChange={pageChange}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: MyDataCustomCell,
                }}
              >
                <Column
                  field="image_name"
                  title="Image"
                  width={100}
                  cells={{
                    data: MyImageCommandCell,
                  }}
                  filterable={false}
                  // locked={true}
                />
                <Column
                  field="order_no"
                  title="Order No"
                  width={100}
                  cells={{
                    data: (props: any) => (
                      <td>
                        <div style={{ color: "green" }}>
                          <strong>
                            {props.dataItem?.order_no}
                            {props.dataItem?.ordersub_no
                              ? `.${props.dataItem?.ordersub_no}`
                              : ""}
                          </strong>
                        </div>
                      </td>
                    ),
                  }}
                />
                <Column
                  field="party_name"
                  title="Party Name"
                  width={200}
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="item_name"
                  title="Product Name"
                  width={200}
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="order_date"
                  title="Order Date"
                  width={130}
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="delivery_date"
                  title="Delivery Date"
                  width={130}
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="order_no"
                  title="Actions"
                  cells={{ data: MyEditCommandCell }}
                  width={90}
                  filterable={false}
                  locked={true}
                />
              </KendoGrid>
            </GridLayoutItem>
          </GridLayout>
        </div>
      </CustomAppDialog>
    </>
  );
};

const ViewProductImages = () => {
  const processByImageList = useAppSelector(
    (state) => state.item.ProcessByImageList,
  );
  const ghatViewImageDialog = useAppSelector(
    (state) => state.ghat.GhatViewImageDialog,
  );
  const loading = useAppSelector((state) => state.item.loading);
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();

  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    centerMode: true,
    centerPadding: "0px",
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleOpenImage = (url: string) => {
    if (url && typeof url === "string") {
      window.open(url);
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <CustomAppDialog open={ghatViewImageDialog}>
        {/* Image Gallery */}
        <div style={{ width: "35vw", height: "50vh" }}>
          <GridLayout gap={{ rows: 10, cols: 10 }}>
            <GridLayoutItem
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.h4 style={{ margin: "0" }}>
                {"Product Images"}
              </Typography.h4>
              <ImCross
                style={{
                  color: "white",
                  background: "red",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "24px",
                }}
                onClick={() => {
                  dispatch(closeGhatViewImageDialog());
                  dispatch(setOrderImageViewPayload(null));
                }}
              />
            </GridLayoutItem>
            <GridLayoutItem>
              {processByImageList && processByImageList?.length === 0 && (
                <AlertBox alert="No Image Available!" />
              )}
            </GridLayoutItem>
            <GridLayoutItem
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                className="slider-container product-view-images"
                style={{ width: "30vw" }}
              >
                {processByImageList && processByImageList.length > 1 ? (
                  <Slider {...settings}>
                    {processByImageList &&
                      processByImageList.length > 0 &&
                      processByImageList.map((image: any, index: number) => (
                        <div>
                          <div key={index} style={{ height: 300 }}>
                            <img
                              src={image.image_name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                              onClick={() => handleOpenImage(image.image_name)}
                            />
                          </div>
                          {/* <Typography.h5 style={{ textAlign: "center" }}>
                                {image.title}
                              </Typography.h5> */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                              gap: 5,
                            }}
                          >
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Title
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.title || "N/A"}
                              </p>
                            </div>
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Process Name
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.process_name || "N/A"}
                              </p>
                            </div>
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Main Image
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.isreadyimage ? "YES" : "NO"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </Slider>
                ) : (
                  <>
                    {processByImageList &&
                      processByImageList.length > 0 &&
                      processByImageList.map((image: any, index: number) => (
                        <div>
                          <div key={index} style={{ height: 300 }}>
                            <img
                              src={image.image_name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                              onClick={() => handleOpenImage(image.image_name)}
                            />
                          </div>
                          {/* <Typography.h5 style={{ textAlign: "center" }}>
                                {image.title}
                              </Typography.h5> */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                              gap: 5,
                            }}
                          >
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Title
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.title || "N/A"}
                              </p>
                            </div>
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Process Name
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.process_name || "N/A"}
                              </p>
                            </div>
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Main Image
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.isreadyimage ? "YES" : "NO"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </>
                )}
              </div>
            </GridLayoutItem>
          </GridLayout>
        </div>
      </CustomAppDialog>
    </>
  );
};
